module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921115649_T.01a61a45.jpg";